import MapMiniature from '@/presentation/assets/img/MapMiniature.png'

interface UserAddressProps {
  address?: {
    street: string
    number: string
    neighborhood: string
    city: string
  }
}

const UserAddress: React.FC<UserAddressProps> = ({ address }) => (
  <div className="mb-6 flex items-center justify-between">
    <div className="flex items-center gap-2">
      <img src={MapMiniature} alt="Address map" />

      {address && (
        <span className="text-gray-500">
          {address.street}, {address.number}, {address.neighborhood},{' '}
          {address.city}
        </span>
      )}
    </div>
  </div>
)

export default UserAddress
